import { useSession } from '../Context';
import { useEffect, useState } from 'react';

const EditablePassword = () => {
  const {
    document: { user },
  } = useSession();
  const [successClass, setSuccessClass] = useState('bg-none');
  const [saved, setSaved] = useState(true);
  const [password, setPassword] = useState('');
  useEffect(() => {
    setPassword(password);
    setSaved(password === '');
  }, [password]);

  const savePassword = () => {
    user.password = password;
    user.save().then((success) => {
      setSuccessClass(success ? 'bg-success' : 'bg-error');
      setSaved(success);
    });
  };

  useEffect(() => {
    if (successClass === 'bg-success') {
      const timer = setTimeout(() => {
        setSuccessClass('bg-none');
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [successClass]);
  return (
    <label className='input'>
      Mot de passe
      <input
        type='password'
        className={`grow ${successClass}`}
        placeholder='Mot de passe'
        value={password}
        onChange={({ target }) => setPassword(target.value)}
      />
      <button
        onClick={savePassword}
        className='btn btn-primary'
        disabled={saved}
      >
        Ok
      </button>
    </label>
  );
};

export default EditablePassword;
